export default __webpack_public_path__ + "static/media/mitsubishi.c7f3e5c4.svg";